import React, { useState, useEffect } from 'react';

function AdminChat() {
	const [chats, setChats] = useState([]); // List of guest chats
	const [selectedChat, setSelectedChat] = useState(null); // Selected guest ID
	const [messages, setMessages] = useState([]); // Messages for selected chat
	const [message, setMessage] = useState(''); // Admin input message

	// Function to fetch guest chats
	const fetchChats = () => {
		fetch('https://hometech-repairs.in/homeTech/get_all_chats.php')
			.then((res) => res.json())
			.then((data) => {
				if (data.chats) {
					// Remove duplicate guest IDs
					const uniqueChats = Array.from(
						new Map(data.chats.map((chat) => [chat.guest_id, chat])).values()
					);
					setChats(uniqueChats);
				} else {
					setChats([]);
				}
			})
			.catch((error) => console.error('Error fetching chats:', error));
	};

	// Function to fetch messages for the selected chat
	const fetchMessages = () => {
		if (selectedChat) {
			fetch(
				`https://hometech-repairs.in/homeTech/get_messages.php?guest_id=${selectedChat}`
			)
				.then((res) => res.json())
				.then((data) => {
					if (data.messages) {
						setMessages(data.messages);

						// Update chat list status
						setChats((prevChats) => {
							const updatedChats = prevChats.map((chat) => {
								if (chat.guest_id === selectedChat) {
									const lastMsg = data.messages[data.messages.length - 1];
									return {
										...chat,
										status: lastMsg.sender === 'admin' ? 'ADMIN' : 'GUEST',
									};
								}
								return chat;
							});
							// Move the active chat to the top
							return updatedChats.sort((a, b) =>
								a.guest_id === selectedChat
									? -1
									: b.guest_id === selectedChat
									? 1
									: 0
							);
						});
					}
				})
				.catch((error) => console.error('Error fetching messages:', error));
		}
	};

	// Fetch chats every 2 seconds
	useEffect(() => {
		fetchChats();
		const chatInterval = setInterval(fetchChats, 2000);
		return () => clearInterval(chatInterval);
	}, []);

	// Fetch messages every 2 seconds when a chat is selected
	useEffect(() => {
		if (selectedChat) {
			fetchMessages();
			const messageInterval = setInterval(fetchMessages, 2000);
			return () => clearInterval(messageInterval);
		}
	}, [selectedChat]);

	// Send a message
	const sendMessage = () => {
		if (!message.trim()) return;

		const newMessage = { guest_id: selectedChat, sender: 'admin', message };

		fetch('https://hometech-repairs.in/homeTech/save_message.php', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(newMessage),
		})
			.then((res) => res.json())
			.then(() => {
				setMessages([...messages, { sender: 'admin', message }]);
				setMessage('');

				// Mark chat as "ADMIN" (Green)
				setChats((prevChats) => [
					{
						guest_id: selectedChat,
						status: 'ADMIN',
					},
					...prevChats.filter((chat) => chat.guest_id !== selectedChat),
				]);
			})
			.catch((error) => console.error('Error sending message:', error));
	};

	return (
		<div
			style={{
				display: 'flex',
				height: '100vh',
				fontFamily: 'Arial, sans-serif',
			}}
		>
			{/* Sidebar for Guest Chats */}
			<div
				style={{
					width: '30%',
					borderRight: '1px solid gray',
					padding: '10px',
					background: '#f8f9fa',
				}}
			>
				<h3>Guest Chats</h3>
				{chats.length === 0 ? (
					<p>No chats available</p>
				) : (
					chats.map((chat) => (
						<div
							key={chat.guest_id}
							onClick={() => setSelectedChat(chat.guest_id)}
							style={{
								cursor: 'pointer',
								padding: '10px',
								borderBottom: '1px solid #ccc',
								background: selectedChat === chat.guest_id ? '#e0e0e0' : '#fff',
								color:
									chat.status === 'ENDED'
										? 'red'
										: chat.status === 'GUEST'
										? 'orange'
										: 'green',
								fontWeight: 'bold',
							}}
						>
							Guest ID: {chat.guest_id} {chat.status === 'ENDED' && '(ENDED)'}
						</div>
					))
				)}
			</div>

			{/* Chat Window */}
			<div style={{ width: '70%', padding: '10px' }}>
				<h3>Chat Window</h3>
				{selectedChat ? (
					<>
						<div
							style={{
								height: '400px',
								overflowY: 'scroll',
								border: '1px solid #ccc',
								padding: '10px',
								background: '#fff',
							}}
						>
							{messages.map((msg, index) => (
								<div
									key={index}
									style={{
										textAlign: msg.sender === 'admin' ? 'right' : 'left',
										margin: '5px 0',
									}}
								>
									<span
										style={{
											background:
												msg.sender === 'admin' ? '#007bff' : '#28a745',
											color: '#fff',
											padding: '8px',
											borderRadius: '5px',
											display: 'inline-block',
										}}
									>
										{msg.message}
									</span>
								</div>
							))}
						</div>

						{/* Input Box */}
						<div style={{ display: 'flex', marginTop: '10px' }}>
							<input
								type="text"
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								placeholder="Type your message..."
								style={{
									flex: 1,
									padding: '8px',
									border: '1px solid #ccc',
									borderRadius: '5px',
								}}
							/>
							<button
								onClick={sendMessage}
								style={{
									padding: '8px 15px',
									marginLeft: '5px',
									background: '#007bff',
									color: 'white',
									border: 'none',
									borderRadius: '5px',
									cursor: 'pointer',
								}}
							>
								Send
							</button>
						</div>
					</>
				) : (
					<p>Select a chat to start a conversation</p>
				)}
			</div>
		</div>
	);
}

export default AdminChat;
